import React, { Component, Fragment } from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import Swal from 'sweetalert2';

export default class TableListItem extends Component {
    constructor(props) {
        super(props);

        this.columns = [
            {
                key: "email",
                text: "email",
                className: "name",
            },
            {
                key: "name",
                text: "nombre",
                className: "name",
            },
            { 
                key: "action",
                text: "Acciones",
                className: "action",
                width: 100,
                align: "left",
                sortable: false,
                cell: record => {
                    return (
                        <Fragment>
                            { record.deleted != 1 &&
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => this.deleteRecord(record)}>{ record.deleted }
                                <i className="fa fa-trash"></i>
                            </button>
                            }
                        </Fragment>
                    );
                }
            }
           
        ];
        this.config = {
            page_size: 50,
            length_menu: [50],
            show_pagination: true,
            show_length_menu:false,
            show_filter: false,
            show_info: true,
            bLengthChange: false,
            grouping: true
        }

        this.state = {
            records: this.props.data
        }
    }

    componentWillReceiveProps = (next_props) => {
        this.setState({records: next_props.data});
    }

    editRecord = (record) => {
        //console.log("Edit Record", record);
        this.props.handleOpenEdit(record);
    }

    deleteRecord = (record) => {
        //console.log(record);
        //si es el ultim registro y esta en una pagina x .. ??
        const arrayCopy = this.state.records.filter( (row) => row.id != record.id);  
        this.props.handleDelete(record);
        this.setState({records: arrayCopy});
    }

    render() {
        return (
            <div>
                <ReactDatatable
                    config={this.config}
                    records={this.state.records}
                    columns={this.columns}
                />
            </div>
        )
    }
}
